import { render, staticRenderFns } from "./EditNotificationType.vue?vue&type=template&id=6e98c7a2&"
import script from "./EditNotificationType.vue?vue&type=script&lang=js&"
export * from "./EditNotificationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports